import { ChangeEventHandler, HTMLAttributes } from 'react';
import { Icon, IconName } from '../../../Graphics';
import { TextInputSize, TextInputVariant } from './enums';
import { joinClassNames } from '../../../../utils';
import { FormGroup } from '../FormGroup';
import styles from './styles.module.scss';

export { TextInputSize, TextInputVariant };

export type TextInputProps = HTMLAttributes<HTMLDivElement> & {
  id: string;
  label: string;
  errorMessage?: string;
  fsBlock?: boolean;
  hideErrorMessage?: boolean;
  hideLabel?: boolean;
  isRequired?: boolean;
  maxLength?: number;
  name?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  size?: TextInputSize;
  value?: string;
  variant?: TextInputVariant;
};

/**
 * @deprecated since 10/12/2020
 * Replaced by Form/TextInput
 */
export const TextInput = ({
  id,
  label,
  errorMessage = '',
  fsBlock = false,
  hideErrorMessage = false,
  hideLabel = false,
  isRequired = false,
  maxLength,
  name = '',
  onChange,
  placeholder = '',
  size = TextInputSize.Medium,
  value = undefined,
  variant = TextInputVariant.Default,
}: TextInputProps) => (
  <FormGroup
    fieldId={id}
    label={label}
    hideLabel={hideLabel}
    errorMessage={errorMessage}
    hideErrorMessage={hideErrorMessage}
    isRequired={isRequired}
  >
    <div
      className={joinClassNames(
        styles.textInput,
        styles[size],
        errorMessage && styles.hasError,
        variant === TextInputVariant.SearchBar && styles.searchBar
      )}
    >
      {variant === TextInputVariant.SearchBar && <Icon name={IconName.Search} />}
      <input
        type="text"
        id={id}
        name={name || id}
        placeholder={placeholder}
        value={value === null ? '' : value}
        maxLength={maxLength}
        onChange={onChange}
        className={joinClassNames(styles.input, fsBlock && 'fs-block')}
      />
    </div>
  </FormGroup>
);
